import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import PaginationSkeleton from 'Component/skeleton/pagination';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const RoleSkeleton = () => {
  return (
    <Box padding="32px 24px">
      <Flex mb="12px" className={styles['section__head']}>
        <SkeletonComponent height="34px" width="212px" />
      </Flex>

      <Flex className={styles['section__filter']}>
        <Flex gap="12px">
          <SkeletonComponent height="34px" width="337px" />
        </Flex>

        <SkeletonComponent height="34px" width="140px" />
      </Flex>

      <Box className={styles['section__table']}>
        <Table className={styles['table__skeleton']}>
          <Thead>
            <Tr>
              <Th className={styles['skeleton__head']} width="250px">
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="60%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <SkeletonComponent height="21px" width="30%" />
              </Th>
              <Th width="194px" className={styles['skeleton__head']}>
                <Flex justifyContent="center">
                  <SkeletonComponent height="21px" width="50%" />
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Iteration
              items={[1, 2, 3, 4, 5, 6, 7, 8]}
              render={(num) => {
                return (
                  <Tr key={num}>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <Flex gap="10px" justifyContent="center">
                        <SkeletonComponent height="42px" width="42px" borderRadius="16px" />
                        <SkeletonComponent height="42px" width="42px" borderRadius="8px" />
                      </Flex>
                    </Td>
                  </Tr>
                );
              }}
            />
          </Tbody>
        </Table>
      </Box>

      <Box className={styles['section__pagination--wrapper']}>
        <Box className={styles['section__pagination']}>
          <PaginationSkeleton />
        </Box>
      </Box>
    </Box>
  );
};

export default RoleSkeleton;
